import {useState} from 'react'
import {getProvince} from '../services'
import {fetchData} from '../util/functionService'
import {mapDataSelect} from '../../../util/functions'
import {LocationModel} from '../model'
const useProvince = () => {
  const [province, setProvince] = useState<LocationModel[]>([])
  const [province2, setProvince2] = useState<LocationModel[]>([])

  const getDataProvince = async (id: string = '') => {
    const response = (await fetchData(getProvince, id)) || []
    return response
  }
  const getProvince1 = async (id: string = '') => {
    const data = await getDataProvince(id)
    const mappedData = mapDataSelect(data)
    setProvince(mappedData)
  }
  const getProvince2 = async (id: string = '') => {
    const data = await getDataProvince(id)
    const mappedData = mapDataSelect(data)
    setProvince2(mappedData)
  }
  const handleClearProvince = async () => {
    setProvince([])
  }
  const handleClearProvince2 = async () => {
    setProvince2([])
  }
  const handleClear = async () => {
    setProvince2([])
    setProvince([])
  }
  return {
    province,
    getProvince1,
    province2,
    getProvince2,
    handleClearProvince,
    handleClearProvince2,
    handleClear,
  }
}

export default useProvince
